import React from 'react';

import {Poll, Chat, ReactionTriggers, Questions} from 'Components/MainStage';

import {translation} from 'Services/TranslationHelpers';

import Base from './Base';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { faPoll } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { asset } from "Services/BaseHelpers";
import { Modal } from "Services";
import PushNotificationModal from "Components/Partials/Modals/PushNotificationModal";
import RemoteLoginModel from "Components/Partials/Modals/RemoteLoginModel";
import User from "Services/User";

export default class Remote extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = true;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
        currentPoll: null,
        tab: null,
        isLandscape: window.innerWidth > window.innerHeight,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        window.addEventListener('resize', this.handleResize);

        if (User && User.loggedIn) {
            this.mountBase();
        } else {
            Modal.open ( {
                component: RemoteLoginModel,
            } );
        }
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
        window.removeEventListener('resize', this.handleResize);
    };

    /**
     * @method handleResize
     */
    handleResize = () => {
        this.setState({ isLandscape: window.innerWidth > window.innerHeight });
    };

    /**
     * @method handleSetTab
     * @param {string} tab
     */
    handleSetTab = (tab) => {
        this.setState({
            tab
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {currentSession, tab, isLandscape} = this.state;

        return (
            <div className={`h-[100svh] w-svw flex justify-between ${isLandscape ? 'flex-row' : 'flex-col' }`}>
            {currentSession && (
                <React.Fragment>
                    <div className="h-[82%] w-full">
                        {tab === null && this.renderNoTab()}
                        {tab === 'chat' && this.renderChat()}
                        {tab === 'reactions' && this.renderReactions()}
                        {tab === 'polls' && this.renderPolls()}
                        {tab === 'questions' && this.renderQuestions()}
                    </div>

                    <div className={`h-20 flex ${isLandscape ? 'flex-col items-end' : ''}`}>
                        { currentSession.chat && this.renderButton('Comment', 'chat', 'comment') }
                        { currentSession.reactions && this.renderButton('React', 'reactions', 'react') }
                        { currentSession.polls_enabled && this.renderButton('Polling', 'polls', 'poll') }
                        { currentSession.questions && this.renderButton( 'Questions', 'questions', 'questions' ) }
                        { currentSession.clevercast_enabled && (currentSession.clevercast_primary_src || currentSession.clevercast_backup_src) && (
                            <a
                                className={`w-full text-xs h-full border-r border-t py-2 px-1 border-white bg-app-agenda-lighter-blue text-white flex items-center justify-center`}
                                href={(currentSession.clevercast_primary_src || currentSession.clevercast_backup_src)}
                                target="_blank"
                                rel="noreferrer"
                                title="Subtitles"
                            >
                                Subtitles
                            </a>
                        )}
                    </div>
                </React.Fragment>
            )}

                { !currentSession && (
                    <div className="h-full w-full flex justify-center items-center">
                    <p>{ translation('main_stage_frontend', 'no_sessions_running') }</p>
                </div>
                )}
            </div>
        );
    }

    /**
     * @method renderNoTab
     * @returns {JSX.Element}
     */
    renderNoTab = () => {
        return (
            <div className="h-full w-full flex justify-center items-center text-3xl font-bold mb-4 text-app-agenda-lighter-blue">
                { translation ( 'main_stage_frontend', 'select_tab_get_started' ) }
            </div>
        );
    };

    /**
     * @method renderChats
     * @return {JSX.Element}
     */
    renderChat = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex-col justify-center items-center bg-white">
                <h1 className="border-b border-app-agenda-lighter-blue py-5 mx-5 text-3xl font-bold mb-4 text-app-agenda-lighter-blue">
                    Comment
                </h1>

                <Chat
                    sessionId={ currentSession?.id }
                    bgColour="bg-white"
                />
            </div>
        );
    };

    /**
     * @method renderReactions
     * @return {JSX.Element}
     */
    renderReactions = () => {
        const { isLandscape, currentSession } = this.state;

        return (
            <div className={`h-full w-full px-8 ${isLandscape ? 'flex flex-row' : 'grid grid-cols-2'} justify-center items-center gap-5 self-center`}>
                <ReactionTriggers
                    sessionId={currentSession?.id}
                    alt="-alt"
                    size="w-20 h-20"
                    className="mx-auto"
                />
            </div>
        );
    };

    /**
     * @method renderPolls
     * @return {JSX.Element}
     */
    renderPolls = () => {
        const {currentPoll, currentSession} = this.state;

        if (!currentPoll) {
            return (
                <div className="h-full w-full flex justify-center items-center">
                    {translation('main_stage_frontend', 'no_polls')}
                </div>
            );
        }

        return (
            <div className="h-full w-full flex-col justify-center items-center">
                <h1 className="border-b border-app-agenda-lighter-blue py-5 mx-5 text-3xl font-bold mb-4 text-app-agenda-lighter-blue">
                    Live Poll
                </h1>
                <Poll
                    poll={ currentPoll }
                    sessionId={ currentSession.id }
                    bgColour="bg-white"
                />
            </div>
        );
    };

    /**
     * @method renderQuestions
     * @return {JSX.Element}
     */
    renderQuestions = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex-col justify-between items-center">
                <h1 className="border-b border-app-agenda-lighter-blue py-5 mx-5 text-3xl font-bold mb-4 text-app-agenda-lighter-blue">
                    Ask a question
                </h1>

                <Questions
                    sessionId={ currentSession?.id }
                    title={null}
                    bgColour="bg-white"
                />
            </div>
        );
    };

    /**
     * @method renderButton
     * @param {string} text
     * @param {string} tab
     * @param icon
     * @param className
     * @return {JSX.Element}
     */
    renderButton = (text, tab, icon, className = '') => {
        const {tab: activeTab} = this.state;

        return (
            <button
                className={`w-full text-xs h-full border-r border-t py-2 px-1 border-white ${activeTab === tab ? 'bg-app-blue text-white' : 'bg-app-agenda-lighter-blue text-white'} ${className}`}
                onClick={() => this.handleSetTab(tab)}
            >
            <div className="h-full flex flex-col justify-center items-center">
                <img src={asset('/images/menu/' + icon + '.png')} alt="icon" className="h-6 w-6" />
                {text}
            </div>
        </button>
        );
    };
}
